import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES, NAV_LINKS } from "@/data/site";

const Footer = () => (
  <footer className="bg-navy text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/assets/logo.png" alt="Daksh DDS Security Service Pvt. Ltd. logo" className="h-12 w-auto rounded-sm" />
            <div className="leading-tight">
              <span className="block font-heading font-extrabold text-white text-lg tracking-tight">DAKSH</span>
              <span className="block text-[10px] font-medium text-slate-400 tracking-[0.18em] uppercase">Detective & Security Services</span>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            {COMPANY.name} — a Non-Government Private Limited Company incorporated on {COMPANY.incorporated}, providing manpower outsourcing, security, facility management and workforce solutions.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase mb-5">Quick Links</h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-sm text-slate-400 hover:text-gold transition-colors inline-flex items-center gap-1 group" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}>
                  {l.label}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
            <li>
              <Link to="/request-quote" className="text-sm text-gold hover:text-gold-hover transition-colors" data-testid="footer-quote-link">Request a Quote</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase mb-5">Our Services</h4>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={s.path} className="text-sm text-slate-400 hover:text-gold transition-colors" data-testid={`footer-service-${s.slug}-link`}>
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase mb-5">Head Office</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin size={16} className="text-gold shrink-0 mt-0.5" />
              <span className="text-slate-400">{COMPANY.address}</span>
            </li>
            <li>
              <a href={COMPANY.phoneHref} className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-phone-link">
                <Phone size={16} className="text-gold shrink-0 mt-0.5" />
                <span className="text-slate-400">{COMPANY.phone}</span>
              </a>
            </li>
            <li>
              <a href={COMPANY.emailHref} className="flex gap-3 hover:text-gold transition-colors break-all" data-testid="footer-email-link">
                <Mail size={16} className="text-gold shrink-0 mt-0.5" />
                <span className="text-slate-400">{COMPANY.email}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
        <p className="text-xs text-slate-500">Incorporated {COMPANY.incorporated} · Managing Director: {COMPANY.md}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
